import {
  BuildScenarioRowResult,
  TableType,
} from '../FinancialForensicsPage/FinancialForensics.types';

export interface ReconciliationDocument {
  fileName: string;
  fileUrl: string;
  fileType: string;
  fileSize: number;
  uploadedBy: string;
  uploadedAt: string;
  startDate: string;
  endDate: string;
  status: string;
  usedFor: string;
}

export interface Reconciliation {
  id: string;
  name: string;
  documents: ReconciliationDocument[];
  notes?: string;
}
export type ReconciliationInfo = Omit<Reconciliation, 'id' | 'documents'>;

export const emptyReconciliationInfo = (): ReconciliationInfo => {
  return {
    name: '',
    notes: '',
  };
};

export interface DataForReconciliation {
  reconciliationId: string;
  vendorId: string;
  serviceId: string;
  reconciliationName: string;
  tableType: TableType;
  type: BuildScenarioRowResult;
}

export const emptyDataForReconciliation = (): DataForReconciliation => {
  return {
    reconciliationId: '',
    vendorId: '',
    serviceId: '',
    reconciliationName: '',
    tableType: 'FIXED',
    type: 'Fees',
  };
};

export interface DocumentDetailsForModal {
  title: string;
  url: string;
}
export const emptyDocumentDetailsForModal = (): DocumentDetailsForModal => {
  return {
    title: '',
    url: '',
  };
};
